/**
 * @file: 层板内部cube排序
 * @author: xiaolong.huang@dmall.com
 */

import { sortAllSelected } from './sortAllSelected';

export default {
    sortAllSelected
};
